<template>
  <div class="GenericAccordion" :class="{ 'border-b border-border-subtle': showBorder }">
    <div
      class="flex items-center justify-between py-16 hover:text-text-base transition-all duration-200 ease-out cursor-pointer"
      :class="{
        'text-text-subtle': !open,
        'text-text-base': open,
      }"
      @click="open = !open"
    >
      <div
        :class="[headlineClass, {
          'type-tagline-xs': size === 'sm',
          'type-headline-base': size === 'base',
          'type-headline-lg': size === 'lg',
          'type-headline-xl': size === 'xl',
        }]"
      >
        {{ headline }}
      </div>
      <img
        src="/icons/angle-down.svg"
        class="transition-all relative"
        :class="{
          'rotate-180': open,
          'w-20 h-20': size !== 'xl',
          'w-24 h-24 top-6': size === 'xl'
        }"
      >
    </div>

    <div
      class="transition-all duration-500 ease-out"
      :class="{
      'overflow-y-visible': open,
      'overflow-y-hidden': !open,
      }"
      :style="{
        maxHeight: open ? `${heightOpen}px` : 0,
      }"
    >
      <div
          ref="accordionContent"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  headline: string,
  headlineClass?: string,
  startOpen?: boolean,
  size?: 'sm' | 'base' | 'lg' | 'xl',
  showBorder?: boolean,
}

const props = withDefaults(defineProps<Props>(), {
  headlineClass: '',
  startOpen: false,
  size: 'sm',
  showBorder: true,
});

const open = ref(props.startOpen || false);
const heightOpen = ref(props.startOpen ? 10000 : 0);

const accordionContent = useTemplateRef('accordionContent');

const observer = ref<MutationObserver | null>(null);

onMounted(()=> {
  getContentHeight();

  observer.value = new MutationObserver(getContentHeight);

  observer.value.observe(accordionContent.value, {
    childList: true,
    subtree: true,
  });

});

onBeforeUnmount(() => {
  observer.value?.disconnect();
});

const getContentHeight = () => {
  heightOpen.value = accordionContent.value?.scrollHeight || 10000;
};

</script>

<style scoped lang="postcss">
</style>
